module.exports = __webpack_public_path__ + "img/744.3dbfe1ee.jpg";